import { Tabs } from '@src/components/ui/tabs/tabs';
import React from 'react';
import { StoreFrontItems } from './items';
import StorefrontReviews from './reviews';
import PropTypes from 'prop-types';

function StorefrontContent(props) {
    const tabs = [
        {
            id: 'services',
            label: `Tasks For Sale [${props.items.TotalRecords}]`,
            className: 'tw-grow',
            iconClass: 'tw-min-w-[16px] tw-text-[12px]',
            Component: StoreFrontItems
        },
        {
            id: 'reviews',
            label: `Task Reviews [${props.merchantFeedback?.ratingsCount || 0}]`,
            className: 'tw-grow',
            iconClass: 'tw-min-w-[16px] tw-text-[12px]',
            Component: StorefrontReviews
        }
    ];

    return <Tabs tabs={tabs} defaultTab='services' tabProps={props} />;
}

StorefrontContent.propTypes = {
    items: PropTypes.shape({
        TotalRecords: PropTypes.number.isRequired
    }).isRequired,
    merchantFeedback: PropTypes.shape({
        ratingsCount: PropTypes.number
    })
};

export default StorefrontContent;
